// extracted by css-extract-rspack-plugin
export default {"withBottomGutter":"withBottomGutter-3Xwx8","withTopGutter":"withTopGutter-2lJer"};